import DialogTitle from '../../../../DialogTitle';
import { FormProvider } from 'react-hook-form';
import { IonicButton } from 'ionic-ui';
import StoreInformationDialog from './steps/StoreInformationDialog';
import { Link } from 'react-router-dom';
import AddressChoiceDialog from './steps/AddressChoiceDialog';
import DirectorsDialog from './steps/DirectorsDialog';
import KycUnderReview from './steps/KycUnderReview';
import { useWalletKyc } from '../../../../../../services/walletSetup/hooks/useWalletKyc';
import DocumentUploadDialog from './steps/DocumentUploadDialog';
import { WalletSetupResume } from '../../../../../../types/wallet/Walletkyc';

type Props = {
  setupResume?: WalletSetupResume | null;
};

export default function WalletKycDialog(props: Props) {
  const { methods, back, next, step, handleFormSubmission, hasStore } =
    useWalletKyc({ setupResume: props.setupResume });

  if (!hasStore)
    return (
      <div className="space-y-2 sm:max-w-[480px] dialog-content text-center">
        <>
          <h5 className="font-medium high-emphasis-text">
            Your account is currently inactive
          </h5>
          <p className="medium-emphasis-text">
            <Link
              to="/dashboard/get-started"
              className="font-medium underline text-primary"
            >
              Create your store and complete your profile
            </Link>
            <span> to continue it.</span>
          </p>
        </>
      </div>
    );

  return (
    <div className="space-y-4 sm:max-w-[480px] dialog-content">
      <DialogTitle>Wallet kyc</DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleFormSubmission}>
          <>{step == 0 && <StoreInformationDialog />}</>
          <>{step == 1 && <AddressChoiceDialog />}</>
          <>{step == 2 && <DirectorsDialog />}</>
          <>{step == 3 && <DocumentUploadDialog />}</>
          <>{step == 4 && <KycUnderReview />}</>
          <div className="flex gap-2 justify-between flex-wrap">
            {step == 1 && (
              <IonicButton
                className="flex-1 min-w-fit"
                variant="outline"
                type="button"
                onClick={back}
              >
                Back
              </IonicButton>
            )}
            {step < 2 && (
              <IonicButton
                className="flex-1 min-w-fit"
                type="button"
                onClick={next}
              >
                Next
              </IonicButton>
            )}
            {step === 2 && (
              <IonicButton
                className="flex-1 min-w-fit"
                type="button"
                onClick={next}
              >
                Continue
              </IonicButton>
            )}
            {step === 3 && (
              <IonicButton className="flex-1 min-w-fit" type="submit">
                submit
              </IonicButton>
            )}
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
